'use strict';
import angular from 'angular';
var RxCredentialEditController = /** @class */ (function () {
    /*@ngInject*/
    function RxCredentialEditController(Auth, $state, $log, $cookies, $scope, $mdToast, $timeout, $filter, Util, RxCredentialEditService, Upload, RxCredentialEditEvents, googleAnalytic) {
        this.credentialType = null;
        this.credentialTypes = ['License'];
        this.selectedCredentialType = null;
        this.selectedDoctorType = null;
        this.selectedCredential = null;
        this.sortType = "doctorType";
        this.sortReverse = false; // set the default sort order
        this.loadingBar = false;
        this.fileUploaded = true;
        this.files = null;
        this.file = null;
        this.log = null;
        this.progressPercentage = 0;
        this.credentialIdToDelete = null;
        this.errors = {
            havePageErrors: false,
            pageErrors: '',
            pageErrorType: ''
        };
        this.showAlert = false;
        this.closeAlertMessage = function () {
            this.showAlert = false;
        };
        this.$scope = $scope;
        this.$mdToast = $mdToast;
        this.$log = $log;
        this.Upload = Upload;
        this.$cookies = $cookies;
        this.$timeout = $timeout;
        this.rxCredentialEditService = RxCredentialEditService;
        this.Util = Util;
        this.$filter = $filter;
        this.RxCredentialEditEvents = RxCredentialEditEvents;
        this.GoogleAnalyticsService = googleAnalytic;
        this.Auth = Auth;
        var self = this;
        this.currentDate = new Date();
        this.maxDate = new Date("2999-12-31");
        if (self.mode != 'Edit') {
            if (self.credentials && self.credentials.length) {
                console.log('2. Credentials Received ->', self.credentials);
            }
            else {
                //self.credentials = [{
                //  id: 1,
                //  credentialType: null,
                //  doctorType: null,
                //  file: null,
                //  status: null
                //}];
            }
            self.rxCredentialEditService.getRxDoctorTypes().then(function (response) {
                if (response && response.status == 200 && response.data.errors.length <= 0) {
                    self.doctorTypes = response.data.response.currentPage;
                }
            });
            self.rxCredentialEditService.getRegionsForCountry('US').then(function (response) {
                if (response && response.status == 200 && response.data.errors.length <= 0) {
                    self.states = response.data.response.currentPage;
                }
            });
        }
        else {
            var cred = angular.copy(self.credentials);
            self.credentials = [];
            self.selectedCredentialType = cred.credentialType;
            self.credentials.push(cred);
            self.selectedCredential = cred;
            self.expirationDate = new Date(cred.expirationDate);
            self.rxCredentialEditService.getRxDoctorTypes().then(function (response) {
                if (response && response.status == 200 && response.data.errors.length <= 0) {
                    self.doctorTypes = response.data.response.currentPage;
                    self.selectedDoctorType = self.getDoctorType(cred.doctorType);
                }
            });
            self.rxCredentialEditService.getRegionsForCountry('US').then(function (response) {
                if (response && response.status == 200 && response.data.errors.length <= 0) {
                    self.states = response.data.response.currentPage;
                    self.selectedState = self.getState(cred.stateIssued);
                }
            });
        }
        $scope.$watch('rx.files', function () {
            // self.upload(self.selectedCredential);
        });
        $scope.$watch('rx.file', function (newVal, oldVal) {
            if (newVal == oldVal)
                return;
            if (self.file != null) {
                self.showAlert = false;
                if (self.file.size) {
                    if (self.file.size > 1000000 || self.file.type == "application/msword" || self.file.type == "application/vnd.ms-excel") {
                        self.Util.setPageErrors('Please use one of our accepted file types: jpg, png, pdf, or gif. File size limit 1MB.', '', self);
                        self.fileUploaded = true;
                        self.$timeout(function () {
                            self.showAlert = true;
                        }, 0);
                    }
                    if (self.areAllFieldsExceptFileUploadValid()) {
                        //self.loadingBar = true;
                        //self.files = [self.file];
                    }
                    else {
                        alert('Select Credential Type before adding the File');
                    }
                }
                else {
                    self.Util.setPageErrors('Cannot upload empty file', '', self);
                    self.showAlert = true;
                }
            }
        });
        self.log = '';
        // Listening to the event from submit button in parent (container) template
        $scope.$on('submitForm', function (event, data) {
            self.onUpdate({
                $event: {
                    credentials: self.credentials
                }
            });
        });
    }
    RxCredentialEditController.prototype.uploadRxCredential = function () {
        this.updateCred(this.selectedCredential);
        this.upload(this.selectedCredential);
    };
    RxCredentialEditController.prototype.uploadFile = function () {
        var self = this;
        self.fileUploaded = false;
    };
    RxCredentialEditController.prototype.areAllFieldsExceptFileUploadValid = function () {
        if (this.selectedDoctorType != null && this.selectedCredentialType != null
            && this.licenseNo != null && this.expirationDate != null && this.credentialForm.expirationDate.$valid && this.selectedState != null)
            return true;
        else
            return false;
    };
    RxCredentialEditController.prototype.getState = function (stateIssued) {
        for (var i = 0; i < this.states.length; i++) {
            if (this.states[i].regionCode == stateIssued) {
                return this.states[i];
            }
        }
    };
    RxCredentialEditController.prototype.getDownloadUrl = function (credential) {
        var self = this;
        var downloadUrl = "api/account/credentials/" + credential.credentialId + "/download";
        return downloadUrl;
    };
    RxCredentialEditController.prototype.upload = function (cred) {
        var self = this;
        console.log('Uploading rx credential ->', cred);
        if (cred) {
            if (!cred.$error && cred.credentialType != null) {
                var xsrf_token = this.$cookies.get('XSRF-TOKEN');
                var credType;
                console.log('cred type -> ', cred.credentialType.toLowerCase());
                if (cred.credentialType.toLowerCase() == 'license') {
                    credType = 3;
                }
                else {
                    credType = 2;
                }
                console.log('Uploading Cred Type ->', credType);
                self.Upload.upload({
                    url: '/api/account/rx/' + cred.credentialId,
                    method: 'PUT',
                    headers: {
                        'X-XSRF-TOKEN': xsrf_token
                    },
                    data: {
                        doctorTypeId: cred.doctorType.doctorTypeID,
                        doctorTypeKey: cred.doctorType.doctorTypeKey,
                        credentialType: credType,
                        licenseNumber: cred.licenseNumber,
                        expirationDate: cred.expirationDate,
                        stateIssued: cred.stateIssued,
                        file: cred.file
                    }
                }).then(function (resp) {
                    self.$timeout(function () {
                        var mesg;
                        if (resp.status == 200 && resp.config.data.file) {
                            mesg = 'file: ' +
                                resp.config.data.file.name;
                        }
                        mesg = mesg + ', Response: ' + JSON.stringify(resp.data) + '\n';
                        console.log(mesg);
                        self.loadingBar = false;
                        if (resp.status != 200 || (resp.data && resp.data.errors && resp.data.errors.length)) {
                            if (resp.status === 413) {
                                var errorResponse = resp;
                                errorResponse.data = {
                                    errors: 'Image size exceeds maximum allowed limit. Please upload an image with a smaller file size.'
                                };
                                self.Util.handleApiError(errorResponse, self);
                            }
                            else {
                                self.Util.handleApiError(resp, self);
                            }
                        }
                        else {
                            self.showSimpleToast("Changes have been saved.", '');
                            // Analytics - GTM Integration
                            var eventData = self.RxCredentialEditEvents.practitionerCredentialEvents['uploadCredential'];
                            self.GoogleAnalyticsService.sendGTMEvent(eventData, {
                                practitionerId: self.Auth.getLoggedInUser().customerId
                            });
                            self.Util.resetApiError(self);
                            self.$scope.$emit('credentialUploaded', resp.data);
                            self.credentialBeingEdited = null;
                            self.file = null;
                        }
                    });
                }, function (response) {
                    self.loadingBar = false;
                    if (response.status != 200 || (response.data && response.data.errors)) {
                        cred.status = 'Upload Failed';
                        self.Util.handleApiError(response, self);
                    }
                }, function (evt) {
                    self.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if (cred.file != null) {
                        var mesg = 'progress: ' + self.progressPercentage + '% ' + evt.config.data.file.name + '\n';
                        console.log(mesg);
                    }
                    // cred.status = 'UPLOADING';
                });
            }
        }
    };
    RxCredentialEditController.prototype.getDoctorType = function (doctorDescription) {
        for (var i = 0; i < this.doctorTypes.length; i++) {
            if (this.doctorTypes[i].description == doctorDescription) {
                return this.doctorTypes[i];
            }
        }
    };
    RxCredentialEditController.prototype.changeCredential = function (credential, credType) {
        var self = this;
        self.loadingBar = true;
        console.log('New Cred type ->', credType);
        if (credType) {
            credential.credentialType = credType;
        }
        if (self.credentialForm.$valid) {
            this.updateCred(credential);
            console.log('Sending updated Credential ->', this.selectedCredential);
            this.upload(this.selectedCredential);
        }
        else {
            console.log('Errors on the form -> ', self.credentialForm.$error);
            self.loadingBar = false;
        }
    };
    RxCredentialEditController.prototype.changeCredType = function (credType) {
        console.log('New Cred type ->', credType);
        this.updateCred({
            credentialType: credType
        });
        this.upload(this.selectedCredential);
    };
    RxCredentialEditController.prototype.updateCred = function (credential) {
        var self = this;
        self.selectedCredential.status = 'Upload Pending';
        self.selectedCredential.file = self.file;
        self.selectedCredential.doctorType = self.selectedDoctorType;
        self.selectedCredential.credentialType = credential.credentialType;
        self.selectedCredential.licenseNumber = self.licenseNo;
        credential.licenseNo = self.licenseNo;
        self.selectedCredential.expirationDate = self.getExpirationDate(self.expirationDate);
        self.selectedCredential.stateIssued = self.selectedState.regionCode;
    };
    RxCredentialEditController.prototype.editCredential = function (credential) {
        var self = this;
        self.cancelDelete();
        this.credentialBeingEdited = credential.credentialId;
        this.mode = 'Edit';
        self.uploadError = false;
        self.uploadErrorMsg = '';
        this.selectedCredentialType = credential.credentialType;
        this.selectedCredential = credential;
        var expirationDate = new Date(credential.expirationDate);
        self.expirationDate = this.$filter('date')(expirationDate, 'yyyy-MM-dd');
        self.licenseNo = credential.licenseNo;
        this.rxCredentialEditService.getRxDoctorTypes().then(function (response) {
            if (response.status == 200 && response.data.errors && response.data.errors.length == 0) {
                self.doctorTypes = response.data.response.currentPage;
                self.selectedDoctorType = self.getDoctorType(credential.doctorType);
            }
        });
        self.rxCredentialEditService.getRegionsForCountry('US').then(function (response) {
            if (response && response.status == 200 && response.data.errors.length <= 0) {
                self.states = response.data.response.currentPage;
                self.selectedState = self.getState(credential.stateIssued);
            }
        });
    };
    RxCredentialEditController.prototype.validateRxExpirationDate = function () {
        var self = this;
        if (self.expirationDate != undefined && self.expirationDate != null) {
            var expDate = new Date(self.expirationDate);
            var currentDate = new Date(self.currentDate);
            currentDate.setHours(0, 0, 0, 0);
            if (typeof expDate === 'object') {
                if (expDate > self.maxDate || expDate < currentDate) {
                    this.setRxExpirationDateValidity(false);
                }
                if (expDate < self.maxDate && expDate >= currentDate) {
                    this.setRxExpirationDateValidity(true);
                }
            }
            else {
                this.setRxExpirationDateValidity(false);
            }
        }
    };
    RxCredentialEditController.prototype.setRxExpirationDateValidity = function (isValid) {
        var self = this;
        self.credentialForm.expirationDate.$error = (isValid === true) ? {} : { 'invalid': true };
        self.credentialForm.expirationDate.$invalid = (isValid === true) ? false : true;
        self.credentialForm.expirationDate.$valid = (isValid === true) ? true : false;
    };
    RxCredentialEditController.prototype.getExpirationDate = function (expirationDate) {
        var nowDate = new Date();
        var d = new Date(expirationDate);
        var expDate;
        if (d.getHours() == 0 && d.getMinutes() == 0) {
            expDate = d.getFullYear() + '-' + (d.getMonth() + 1).padLeft() +
                '-' + d.getDate().padLeft() + ' ' + nowDate.getHours().padLeft() +
                ':' + nowDate.getMinutes().padLeft() + ':' + nowDate.getSeconds().padLeft() +
                '.' + nowDate.getMilliseconds().padLeft();
        }
        else {
            expDate = d.getFullYear() + '-' + (d.getMonth() + 1).padLeft() +
                '-' + d.getDate().padLeft() + ' ' + d.getHours().padLeft() +
                ':' + d.getMinutes().padLeft() + ':' + d.getSeconds().padLeft() +
                '.' + d.getMilliseconds().padLeft();
        }
        return expDate;
    };
    RxCredentialEditController.prototype.addCredential = function () {
        this.credentials.push({
            id: this.credentials.length + 1,
            credentialType: null,
            fileName: null,
            status: null
        });
    };
    RxCredentialEditController.prototype.deleteCredential = function (credential) {
        var self = this;
        self.credentialBeingEdited = null;
        this.rxCredentialEditService.deleteCredential(credential.credentialId)
            .then(function (response) {
            if (response.status == 200 && response.data.errors.length == 0) {
                self.credentials = self.credentials.filter(function (x) {
                    return x.credentialId != credential.credentialId;
                });
            }
        });
    };
    RxCredentialEditController.prototype.setDeleteCredentialId = function (id) {
        this.credentialIdToDelete = this.credentialIdToDelete == id ? null : id;
    };
    RxCredentialEditController.prototype.cancelDelete = function () {
        this.credentialIdToDelete = null;
    };
    /**
     * Create filter function for a query string
     */
    RxCredentialEditController.prototype.createFilterFor = function (query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(state) {
            return (angular.lowercase(state.regionName).indexOf(lowercaseQuery) === 0);
        };
    };
    /**
     * Search for states
     */
    RxCredentialEditController.prototype.querySearch = function (query) {
        var self = this;
        var results = query ? self.states.filter(self.createFilterFor(query)) : self.states;
        return results;
    };
    RxCredentialEditController.prototype.showSimpleToast = function (message, addMsg) {
        var msg = (addMsg != null) ? addMsg : '';
        this.$mdToast.show(this.$mdToast.simple()
            .textContent(message + ' \n' + msg)
            .parent(document.querySelectorAll('#rx-toast'))
            .position('top right')
            .hideDelay(2000));
    };
    // This is to ensure that any changes to our local user object don't reflect in
    // the parent object that was passed to us.
    RxCredentialEditController.prototype.$onChanges = function (changes) {
        if (changes.credentials) {
            this.credentials = angular.copy(this.credentials);
        }
    };
    return RxCredentialEditController;
}());
export default RxCredentialEditController;
//# sourceMappingURL=rx-credential-edit.controller.js.map